<script setup lang="ts">
import GestionUnites from '@/components/vegco/GestionUnites.vue'
import GestionProduits from '@/components/vegco/GestionProduits.vue'
import GestionBalises from '@/components/vegco/GestionBalises.vue'

definePage({
  meta: {
    id: 'vgco.gestion',
    icon: 'mdi-cog-outline',
    title: 'Gestion Vegco',
    drawerIndex: 8,
    requiresAuth: true,
    requiresAdmin: true,
    requiresSiteAccess: 'vegco',
  },
})

const theme = useTheme()
const activeTab = ref('unites')
</script>

<template>
  <v-card class="mx-4 my-4 page-card" rounded="xl" style="height: 85vh; display: flex; flex-direction: column;">

    <!-- ── Page header ─────────────────────────────────────────────── -->
    <div class="page-header px-5 pt-5 pb-3">
      <div class="d-flex align-center" style="gap: 12px;">
        <v-avatar color="primary" variant="tonal" size="44" rounded="lg">
          <v-icon icon="mdi-cog-outline" size="26"/>
        </v-avatar>
        <div>
          <div class="text-h6 font-weight-bold" style="line-height: 1.2;">Gestion Vegco</div>
          <div class="text-caption text-medium-emphasis">Unités, produits et balises (réservé aux administrateurs)</div>
        </div>
      </div>
    </div>

    <v-divider/>

    <!-- ── Tabs ─────────────────────────────────────────────────────── -->
    <v-tabs v-model="activeTab" density="compact" class="px-2 pt-1" color="primary">
      <v-tab value="unites" prepend-icon="mdi-ruler-square-compass">Unités</v-tab>
      <v-tab value="produits" prepend-icon="mdi-package-variant-closed">Produits</v-tab>
      <v-tab value="balises" prepend-icon="mdi-tag-multiple-outline">Balises</v-tab>
    </v-tabs>

    <v-divider/>

    <!-- ── Content ──────────────────────────────────────────────────── -->
    <div style="flex: 1 1 auto; overflow: auto;">
      <v-window v-model="activeTab">
        <v-window-item value="unites">
          <GestionUnites/>
        </v-window-item>
        <v-window-item value="produits">
          <GestionProduits/>
        </v-window-item>
        <v-window-item value="balises">
          <GestionBalises/>
        </v-window-item>
      </v-window>
    </div>

  </v-card>
</template>

<style scoped>
/* ── Page header ─────────────────────────── */
.page-header {
  background: v-bind('theme.global.name.value === "dark" ? "rgba(var(--v-theme-surface-variant), 0.25)" : "rgba(var(--v-theme-primary), 0.04)"');
}
</style>
